import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";

import type { ReactNode } from "react";

import type { IModalProps } from "@atoms/modal";

export type IShowModalOptions = Omit<
  IModalProps,
  "children" | "open" | "onClose"
> & {
  noBox?: boolean;
  noBoxPadding?: boolean;
};

interface IModalState {
  isOpen: boolean;
  children: ReactNode;
  options?: IShowModalOptions;
}

const INIT_DATA: IModalState = {
  isOpen: false,
  children: <div />,
};

export const useModalStore = create<IModalState>()(
  subscribeWithSelector(
    devtools(() => INIT_DATA, {
      enabled: !import.meta.env.PROD,
      name: "uiStore",
    }),
  ),
);

export const showModal = (children: ReactNode, options?: IShowModalOptions) => {
  useModalStore.setState({
    isOpen: true,
    children,
    options,
  });
};

export const closeModal = () => {
  useModalStore.setState({ isOpen: false });
};

export const clearModalOptions = () => {
  useModalStore.setState({ options: undefined });
};
